module.exports = __webpack_public_path__ + "static/img/7696_phase_function_Paper_PointsHejduk_Prediction.41b2093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7696_phase_function_Paper_PointsHejduk_Prediction.png
// module id = p4B7
// module chunks = 0